import React from "react";
import BannerImg from "../../../assets-user/sliderImg.png";
import SearchCard from "./SearchCard";
import MobileBannerImg from "../../../assets-user/sliderImg1.png";
import MediumBannerImg from "../../../assets-user/sliderImg2.png";

const HeroSlider = () => {
  return (
    <div className="relative w-full">
      {/* Background and content */}
      <div className="relative w-full h-[300px] lg:h-[350px] xl:h-[430px] flex items-center">
        {/* Static Background Image */}
        <div
          className="absolute inset-0 bg-center bg-no-repeat bg-cover lg:hidden"
          style={{ backgroundImage: `url(${MobileBannerImg})` }}
        ></div>

        {/* ✅ Medium Screen Image */}
        <div
          className="absolute inset-0 bg-center bg-no-repeat bg-cover hidden md:block"
          style={{ backgroundImage: `url(${MediumBannerImg})` }}
        ></div>

        {/* ✅ Desktop / Large Screen Image */}
        <div
          className="absolute inset-0 bg-center bg-no-repeat bg-cover hidden lg:block"
          style={{ backgroundImage: `url(${BannerImg})` }}
        ></div>

        {/* Content */}
        <div className="relative z-10 px-4 md:px-10">
          <h1
            data-aos="fade-up"
            className="mb-3 md:mb-4 text-[#EBEBEB] text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black leading-[150%] tracking-[0.1%] text-left w-full md:w-2/3"
            style={{
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            <span style={{ color: "#D7B88A" }}>LeadBook</span> – The Real Estate
            Hub
          </h1>

          <p
            data-aos="fade-up"
            data-aos-delay="20"
            className="text-[#EBEBEB] font-medium text-sm sm:text-lg md:text-xl lg:text-2xl leading-[159%] tracking-[1%] text-left md:w-2/3"
          >
            Your one-stop platform for buying, selling, and renting properties
            with smart tools and trusted services.
          </p>
        </div>

        {/* SearchCard positioned absolutely relative to parent */}
        <div className="absolute inset-x-0 top-80 lg:top-80 xl:top-96 justify-center px-4 md:px-10">
          <SearchCard />
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;
